module.exports = __webpack_public_path__ + "static/media/campk12.ddfade62.png";